var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFinancesColored = function SvgFinancesColored(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 1000 1000",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F08D00",
    d: "m541.6 16.4 435.6 372.4c36.6 35.9-25.4 62.3-76.7 62.3H99.7c-51.4 0-113.6-26.6-76.8-62.5L461.5 16.2c22.3-21.7 57.8-21.6 80.1.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCFCFC",
    d: "M883.9 916.8V526.4c0-19.5-15.8-35.4-35.4-35.4H151.2c-19.5 0-35.4 15.8-35.4 35.4v390.4H86.5c-23 0-41.6 18.6-41.6 41.6s18.6 41.6 41.6 41.6h824.3c23 0 41.6-18.6 41.6-41.6s-18.6-41.6-41.6-41.6zm-83.2-265.4v265.5h-119V651.4c0-38.3 25.2-69.4 56.3-69.4h6.6c31 0 56.1 31 56.1 69.4m-244.6 0v265.5h-119V651.4c0-38.3 25.2-69.4 56.3-69.4h6.6c30.9 0 56.1 31 56.1 69.4M255.3 582c31.1 0 56.3 31.1 56.3 69.4v265.5H199V651.4c0-38.4 25.2-69.4 56.3-69.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 500.1,
    cy: 266.6,
    r: 73.5,
    fill: "#135899"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFinancesColored);
export default ForwardRef;